<div class="job-tooltip">
{{#customer}}
  <div>
    <div class="caption text-uppercase font-weight-bold">Requester</div>
    <div class="body-1">{{{ customer }}}</div>
  </div>
{{/customer}}
{{#details}}
  {{#customer}}
  <br>
  {{/customer}}
  <div>
    <div class="caption text-uppercase font-weight-bold">Details</div>
    <div class="job-details">{{{ details }}}</div>
  </div>
{{/details}}
</div>
